var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllowsOvernight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.5c-.008 2.512 1.215 3.941 4 4-2.584-.01-3.869 1.375-4 4-.022-2.475-1.131-4.002-4-4 2.568-.035 3.988-1.275 4-4zm-5-6.5c-.006 1.57.76 2.463 2.5 2.5-1.615-.006-2.418.86-2.5 2.5-.014-1.547-.707-2.502-2.5-2.5 1.603-.022 2.494-.797 2.5-2.5zm7-6.5c-.006 1.885.912 2.957 3 3-1.938-.007-2.902 1.032-3 3-.016-1.856-.85-3.002-3-3 1.926-.025 2.992-.956 3-3z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12c0-5.094 2.806-9.474 6.827-11.42A11.38 11.38 0 0012 .5C5.648.5.5 5.648.5 12S5.648 23.5 12 23.5c.449 0 .893-.027 1.327-.077C9.306 21.477 6.5 17.096 6.5 12z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgAllowsOvernight;